import { Moon, Sun } from 'lucide-react';
import type { ReactElement } from 'react';

import { ToggleGroup, ToggleGroupItem } from '@/design-system/components/ui';
import { useSettings } from '@/hooks/useSettings';

type PaletteMode = 'light' | 'dark';

interface ThemeOption {
  label: string;
  value: PaletteMode;
  icon: ReactElement;
}

export const themeOptions: ThemeOption[] = [
  {
    label: 'Light',
    value: 'light',
    icon: <Sun size={16} />,
  },
  {
    label: 'Dark',
    value: 'dark',
    icon: <Moon size={16} />,
  },
];

export default function ThemeSwitcher() {
  const { handleUpdate, paletteMode } = useSettings();

  return (
    <ToggleGroup
      type="single"
      value={paletteMode}
      onValueChange={(value) => {
        if (value) {
          handleUpdate({ paletteMode: value as PaletteMode });
        }
      }}
      variant="ghost"
      size="sm"
    >
      {themeOptions.map((option) => (
        <ToggleGroupItem key={option.value} value={option.value} aria-label={option.label}>
          {option.icon}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
}
